<template>
  <div class="grid-x flex-grow divide-x">
    <div class="cell large-8 cell-block-y">
      <Loading :loading="waitPending">
        <div
          class="grid-y divide-y"
          v-if="object">
          <div class="cell p-8">
            <div class="flex items-center justify-between">
              <div class="flex flex-row items-center space-x-6">
                <div
                  class="w-20 h-20 rounded-full overflow-hidden"
                  v-if="object.photoAttach">
                  <Attachment
                    class="w-full h-full object-cover object-center"
                    :id="object.photoAttach"/>
                </div>
                <h2 class="text-2xl font-bold">
                  {{ $delve(object, 'name') }}
                </h2>
              </div>
            </div>
          </div>
          <ObjectDetails :subject="object"/>
        </div>
      </Loading>
    </div>
    <div class="cell large-4 cell-block-y padding-2 flex flex-col">
      <div class="grid-y flex-grow">
        <div class="cell flex-grow flex flex-col justify-end">
          <div class="flex flex-row items-center">
            <button
              class="btn btn-xs btn-info flex-grow"
              @click="$router.push({
                name: 'objects.edit',
                params: {
                  id,
                },
              })">
              Редактировать объект
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ObjectDetails from '@/components/ObjectDetails.vue';
import Attachment from '@/components/global/Attachment.vue';
import Loading from '@/components/Loading.vue';

export default {
  components: {
    ObjectDetails,
    Attachment,
    Loading,
  },
  props: {
    id: {
      required: true,
    },
    object: {
      required: true,
    },
  },
  computed: {
    waitKey() {
      return `fetch.object.${this.id}`;
    },
    waitPending() {
      return this.$wait.is(this.waitKey);
    },
  },
};
</script>
